'use strict';

var _ = require('underscore');
var Backbone = require('backbone');
var moment = require('moment-timezone');

var Time = require('../models/time').default;

export default Backbone.Collection.extend({

  url: '/online_bookings/ajax_times',
  model: Time,

  parse: function (response) {
    if (response.data.availability !== undefined) {
      return response.data.availability.dates.date;
    } else {
      return [];
    }
  },

  adjustWithTimezone: function (appointment) {
    var srcTz = window.localStorage.getItem('previous_timezone') || appointment.getLocation().get('timezone');
    var destTz = window.localStorage.getItem('timezone') || srcTz;
    var models = [];
    var outliers = [];
    var changingTimezones = srcTz !== destTz;

    for (var i = 0; i < this.length; i++) {
      var model = this.models[i];

      model.set('timezone_abbr', moment.tz(destTz).zoneAbbr());
      model.set('time', _.map(model.get('time'), function (t) {
        var timestamp = t.hasOwnProperty('adjusted_start') ?
          t.adjusted_start.clone().format('YYYY-MM-DD HH:mm:ss') :
          model.get('value') + ' ' + t.start;

        var original = moment.tz(timestamp, srcTz);

        t.adjusted_start = original.clone().tz(destTz);

        if (changingTimezones) {
          t.timestamp = t.adjusted_start.clone().format('X');

          var adjusted = moment(t.adjusted_start.clone().format('YYYY-MM-DD'));
          var start = moment(original.clone().format('YYYY-MM-DD'));
          var diff = adjusted.diff(start, 'days');

          if (diff !== 0) {
            var index = i + diff;

            if (!outliers[index]) {
              outliers[index] = [];
            }

            outliers[index].push(t);

            return null;
          }
        }

        return t;
      }).filter(function (item) {
        return item !== null;
      }));

      models[i] = model;
    }

    if (changingTimezones) {
      Object.keys(outliers).forEach(function(key) {
        var items = outliers[key];
        var model = models[key];

        if (typeof model !== 'undefined') {
          var times = model.get('time');

          for (var i = 0; i < items.length; i++) {
            var item = items[i];
            times.push(item);
          }

          times = times.sort(function(a, b) {
            return a.timestamp - b.timestamp;
          });

          model.set('time', times);
          models[key] = model;
        }
      });
    }

    return models;
  },

  findFirstWithTimes: function () {
    return this.find(function (day) {
      return day.hasTimes();
    });
  },

  findIndexOfFirstWithTimes: function () {
    var model = this.find(function (day) {
      return day.hasTimes();
    });

    if (!model) {
      return -1;
    }

    return this.indexOf(model);
  },

  findIndexOfDateAndTime: function (date, time) {
    var model = this.find(function (day) {
      return day.get('value') === date && day.hasTime(time);
    });

    if (!model) {
      return -1;
    }

    return this.indexOf(model);
  },

  findIndexOfDate: function (date) {
    var model = this.find(function (day) {
      return day.get('value') === date;
    });

    if (!model) {
      return -1;
    }

    return this.indexOf(model);
  },

  isDateFirstInCollection: function (date) {
    return this.findIndexOfDate(date) == 0;
  },

  isDateLastInCollection: function (date) {
    return this.findIndexOfDate(date) == this.length - 1;
  },

  getAvailableTimeCount: function () {
    var count = 0;

    this.each(function (model) {
      count += model.get('time').length;
    });

    return count;
  },

});
